
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lite-home-page",
      function () {
        return require("private-next-pages/lite-home-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lite-home-page"])
      });
    }
  